/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments400,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments401,
  GetApiV1CourseregistrationDocumentCourseregistrationidAttachments500,
} from "../../types/courseRegistrationDocumentController/GetApiV1CourseregistrationDocumentCourseregistrationidAttachments.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1CourseregistrationDocumentCourseregistrationidAttachments } from "../../clients/courseRegistrationDocumentController/getApiV1CourseregistrationDocumentCourseregistrationidAttachments.ts";

export const getApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryKey =
  (
    courseRegistrationId: GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams["courseRegistrationId"],
  ) =>
    [
      {
        url: "/api/v1/courseregistration/document/:courseRegistrationId/attachments",
        params: { courseRegistrationId: courseRegistrationId },
      },
    ] as const;

export type GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryKey =
  ReturnType<
    typeof getApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryKey
  >;

export function getApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryOptions(
  courseRegistrationId: GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams["courseRegistrationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryKey(
      courseRegistrationId,
    );
  return queryOptions<
    GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments400
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments401
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments500
    >,
    GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
    typeof queryKey
  >({
    enabled: !!courseRegistrationId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1CourseregistrationDocumentCourseregistrationidAttachments(
        courseRegistrationId,
        { ...config, signal: config.signal ?? signal },
      );
    },
  });
}

/**
 * @description Retorna os grupos de documentos da pessoa vinculada a matricula exigidos pelo curso com status geral, arquivos enviados, dados de aprovação/rejeição e texto OCR, para exibição na aba Documentos do gerenciamento. **(Requer Authorization para autenticação)**
 * @summary Retorna os documentos da pessoa vinculada a matricula (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/document/:courseRegistrationId/attachments}
 */
export function useGetApiV1CourseregistrationDocumentCourseregistrationidAttachments<
  TData =
    GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
  TQueryData =
    GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
  TQueryKey extends QueryKey =
    GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryKey,
>(
  courseRegistrationId: GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsPathParams["courseRegistrationId"],
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryResponse,
        ResponseErrorConfig<
          | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments400
          | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments401
          | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryKey(
      courseRegistrationId,
    );

  const query = useQuery(
    {
      ...getApiV1CourseregistrationDocumentCourseregistrationidAttachmentsQueryOptions(
        courseRegistrationId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments400
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments401
      | GetApiV1CourseregistrationDocumentCourseregistrationidAttachments500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
